import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import { P as PaginationButton } from './PaginationButton-B4M4YmwW.js';
import { b as angleInlineEnd } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { c as createStormTaktId } from '../../TaktIdContext/TaktIdContext.utils-B0CzqlN8.js';

const PaginationNextButton = props => /*#__PURE__*/React__default.createElement(PaginationButton, _extends({
  taktFallbackId: createStormTaktId('pagination-next-button'),
  icon: angleInlineEnd
}, props));
PaginationNextButton.displayName = 'PaginationNextButton';

export { PaginationNextButton as P };
//# sourceMappingURL=PaginationNextButton-CoN9ZyO9.js.map
